import { useEffect, useState } from 'react';
import { isEmptyData, sendAnalyticsEvent, cleanText } from '../../../utils/helper';
import { useSelector, useDispatch } from 'react-redux';
import { setOrder } from '../../../store/reducers/order';
import { BottomSheet } from 'react-spring-bottom-sheet';
import Confirmation from '../Header/Confirmation';
import { removeCart } from '../../../store/reducers/cart';
import { UFOODX_BASE_URL } from '../../../utils/constants';
import useNavigation from '../../../hook/useNavigation';

const active_class = 'text-white bg-[var(--rose-violet)] border-[var(--rose-violet)]';
const inactive_class = 'text-gray-400 bg-gray-100 border-gray-100';

const nameMap = {
	delivery: 'Delivery',
	pickup: 'Self Pick up',
	dinein: 'Dine In',
};

const OrderOption = ({ isDisabled = false, setValues = () => {}, setDefaultValues = () => {} }) => {
	const dispatch = useDispatch();

	const { data: products } = useSelector((store) => store?.product);
	const { cart } = useSelector((store) => store?.cart);

	const { orderTypeOptions, selectedOrderType } = useSelector((store) => store?.order);

	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
	const [pendingType, setPendingType] = useState(null);

	const orderTypePriority = {
		delivery: 1,
		pickup: 2,
		dinein: 3,
	};
	const orderTypeList =
		orderTypeOptions
			?.map((d) => {
				const name = d?.av_name?.toLowerCase();
				return {
					...d,
					label: name,
					name: nameMap[name] || d?.av_name || '',
				};
			})
			.filter(Boolean)
			.sort((a, b) => (orderTypePriority[a.label] || 99) - (orderTypePriority[b.label] || 99)) || [];

	const user = useSelector((store) => store?.user);
	const navigate = useNavigation();
	const { details: outlet } = useSelector((store) => store?.outlet);

	useEffect(() => {
		if (isEmptyData(orderTypeList)) return;
		if (!isEmptyData(selectedOrderType)) return;

		let availability = null;

		if (orderTypeList.length === 1) {
			availability = orderTypeList[0];
		}

		if (!availability) {
			availability = orderTypeList.find((d) => d.label === 'delivery');
		}

		if (!isEmptyData(availability)) {
			const selectedOrderType = orderTypeOptions.find((t) => t?.av_name?.toLowerCase() === availability?.label);
			dispatch(
				setOrder({
					selectedOrderType: selectedOrderType,
				}),
			);

			setDefaultValues((prev) => ({
				...prev,
				orderType: availability?.label,
				availabilityID: availability?.av_id,
				availabilityName: availability?.av_name,
			}));
		}
	}, [orderTypeList, selectedOrderType, dispatch]);

	const handleCheckProductAvability = (type) => {
		if (isEmptyData(cart?.item)) return true;

		const typeClean = cleanText(type);

		const isAllAllowed = cart.item.every((cartItem) => {
			const product = products?.find((p) => Number(p?.product_primary_id) === Number(cartItem?.product_primary_id));

			if (isEmptyData(product?.product_availability)) return true;

			return product.product_availability.some((availability) => cleanText(availability?.label) === typeClean);
		});

		return isAllAllowed;
	};

	const handleClick = (type = null) => {
		if (!type) return;
		const isAllowed = handleCheckProductAvability(cleanText(type?.av_name));
		if (!isAllowed) {
			setPendingType(type);
			setIsShowBottomSheet(true);
			return;
		}
		const selectedOrderType = orderTypeOptions.find((t) => cleanText(t?.av_name) === cleanText(type?.av_name));
		dispatch(
			setOrder({
				selectedOrderType: selectedOrderType,
			}),
		);
    setValues((prev) => ({
      ...prev,
      orderType: type?.label,
      availabilityID: type?.av_id,
      availabilityName: type?.av_name,
    }));
	};

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

  const handleConfirm = async () => {
    if (!pendingType) return;

    try {
      await dispatch(removeCart()).unwrap();

      const selectedOrderType = orderTypeOptions.find((t) => cleanText(t?.av_name) === cleanText(pendingType?.av_name));
      dispatch(setOrder({ selectedOrderType }));

      navigate.push(`${UFOODX_BASE_URL}/${outlet?.storeSlug}/${cleanText(pendingType?.av_name)}`);
      handleCloseBottomSheet();
    } catch (error) {
      console.log('error: ', error);
    }
  };

	const handleCancel = () => {
		handleCloseBottomSheet();
	};

	if (orderTypeList.length === 1) return null;

	return (
		<>
			<div className='p-4 flex justify-between bg-white gap-4 border-b border-gray-200'>
				{orderTypeList.map((type, index) => (
					<button
						key={index}
						type='button'
						disabled={isDisabled}
						onClick={() => handleClick(type)}
						className={`w-full px-2 py-2 rounded-full text-sm font-medium 
						disabled:bg-gray-300 disabled:text-white disabled:border-gray-100 
						${selectedOrderType?.av_name?.toLowerCase() === type?.label ? active_class : inactive_class}`}>
						{type?.name}
					</button>
				))}
			</div>

			<BottomSheet key={'order-type-options'} open={isShowBottomSheet} onDismiss={handleCloseBottomSheet}>
				<Confirmation onConfirm={handleConfirm} onCancel={handleCancel} />
			</BottomSheet>
		</>
	);
};

export default OrderOption;